<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <div class="handle-box">
        <el-row type="flex" align="middle">
          <el-button v-acl="RMC_PROD_MEDICINE_SAVE" v-if="statusView=='S'" size="mini" type="primary" @click="saveData('detailInfo')">保存</el-button>
          <el-button v-acl="RMC_PROD_MEDICINE_SUBMIT" v-if="statusView=='S'" size="mini" type="primary" @click="submitData('detailInfo')">提交</el-button>
          <!-- <el-button size="mini"  type="primary">批准</el-button>
            <el-button size="mini"  type="primary">退回</el-button> -->
        </el-row>
      </div>

      <div class="handle-box" style="padding-bottom:10px;">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">药品清单</p>
        </div>
        <el-form :model="detailInfo" ref="detailInfo" :rules="rules" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Category3" prop="category3Code">
                <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" :disabled="category3List.length>1&&statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sponsor">
                <el-input v-model="detailInfo.sponsorName" disabled placeholder="从供应商集团选择"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Farm" prop="rmcProduceFarmId">
                <el-select v-model="detailInfo.rmcProduceFarmId" :disabled="statusView=='S'?false:true" @change="getFarmGroupId" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in farmList" :label="item.farmName" :value="item.rmcProduceFarmId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Farm Group">
                <el-input disabled v-model="detailInfo.farmGroup" maxlength="100" placeholder="请选择"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="作物名称" prop="cultiVarName">
                <el-select v-model="detailInfo.cultiVarName" multiple :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in cultiVarList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商品名" prop="productName">
                <el-autocomplete class="inline-input" maxlength="100" style="width:100%" v-model="detailInfo.productName" :disabled="statusView=='S'?false:true" :fetch-suggestions="querySearch1" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect1"></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="有效成分" prop="effectiveComponents">
                <el-select v-model="detailInfo.effectiveComponents" filterable @change="getSelectorForEffective" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" v-if="isOther">
              <el-form-item label="有效成分其他" prop="effectiveComponentsOther" :rules="{required:detailInfo.effectiveComponents=='其他'?true:false,message:'请输入有效成分其他',trigger: 'blur'}">
                <el-input v-model="detailInfo.effectiveComponentsOther" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用途分类" prop="useClass">
                <el-select v-model="detailInfo.useClass" clearable :disabled="!isOther" style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in useClassList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isOther?6:12">
              <el-form-item label="含量" prop="contents">
                <el-input v-model="detailInfo.contents" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="producer">
                <el-input v-model="detailInfo.producer" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="剂型" prop="dosageForm">
                <el-select v-model="detailInfo.dosageForm" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in dosageFormList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用方法" prop="usage">
                <el-select v-model="detailInfo.usage" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in usageList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="指导用量" prop="guideUsage">
                <el-input v-model="detailInfo.guideUsage" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="安全间隔期/天" prop="safetyDay">
                <el-input v-model="detailInfo.safetyDay" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入天数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="最多使用次数/季" prop="maximum">
                <el-input v-model="detailInfo.maximum" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="农药登记证号" prop="pesticideNumber">
                <el-input v-model="detailInfo.pesticideNumber" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="GB 2763有限量" prop="finiteQuantity">
                <el-select v-model="detailInfo.finiteQuantity" @change="changeGb" style="width:100%" :disabled="statusView=='S'?false:true" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="其他标准" prop="otherStandard" :rules="{required:detailInfo.finiteQuantity=='N'?true:false,message:'请输入其他标准',trigger: 'blur'}">
                <el-input v-model="detailInfo.otherStandard" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="药品在用状态" prop="medicineUseStatus">
                <ic-select table="TT_RMC_PRODUCE_MEDICINE" :disabled="statusView=='S'?false:true" filterable field="MEDICINE_USE_STATUS" clearable v-model="detailInfo.medicineUseStatus" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态">
                <ic-select table="TT_RMC_PRODUCE_MEDICINE" disabled filterable field="STATUS" clearable v-model="detailInfo.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24" v-if="$route.query.id">
              <el-form-item label="上次修改原因" prop="momentUpdateReason">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit disabled placeholder="请输入内容" v-model="momentUpdateReason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="修改原因" prop="modifyReason">
                <el-tooltip v-if="detailInfo.modifyReason&&detailInfo.modifyReason.length>400" class="item" effect="dark" :content="detailInfo.modifyReason" placement="top-start">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit :disabled="statusView=='S'?false:true" placeholder="请输入内容" v-model="detailInfo.modifyReason"></el-input>
                </el-tooltip>
                <el-input v-else type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit :disabled="statusView=='S'?false:true" placeholder="请输入内容" v-model="detailInfo.modifyReason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row style="margin-top:8px;"  align="middle">
             <el-col :span="6">
                 <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" :disabled="category3List.length>1&&statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Sponsor">
                   <el-input v-model="detailInfo.sponsorName" disabled placeholder="从供应商集团选择" ></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Farm" prop="rmcProduceFarmId">
                     <el-select v-model="detailInfo.rmcProduceFarmId" :disabled="statusView=='S'?false:true" @change="getFarmGroupId" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in farmList" :label="item.farmName" :value="item.rmcProduceFarmId"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Farm Group">
                   <el-input disabled v-model="detailInfo.farmGroup" maxlength="100"   placeholder="请选择" ></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="作物名称" prop="cultiVarName">
                     <el-select v-model="detailInfo.cultiVarName" multiple  :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in cultiVarList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="商品名" prop="productName">
                   <el-autocomplete class="inline-input" maxlength="100" style="width:100%" v-model="detailInfo.productName" :disabled="statusView=='S'?false:true" :fetch-suggestions="querySearch1" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect1" ></el-autocomplete>
                 </el-form-item>
             </el-col>
             <el-col :span="12">
                 <el-form-item label="有效成分" prop="effectiveComponents">
                    <el-select v-model="detailInfo.effectiveComponents" multiple filterable @change="getSelectorForEffective" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="用途分类" prop="useClass">
                     <el-select v-model="detailInfo.useClass" clearable disabled style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in useClassList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="12">
                 <el-form-item label="含量" prop="contents">
                     <el-input v-model="detailInfo.contents" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="生产厂家" prop="producer">
                     <el-input v-model="detailInfo.producer" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="剂型" prop="dosageForm">
                   <el-select v-model="detailInfo.dosageForm" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in dosageFormList" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="使用方法" prop="usage">
                      <el-select v-model="detailInfo.usage" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in usageList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="指导用量" prop="guideUsage">
                     <el-input v-model="detailInfo.guideUsage" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="安全间隔期/天" prop="safetyDay">
                     <el-input v-model="detailInfo.safetyDay" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入天数"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="最多使用次数/季" prop="maximum">
                     <el-input v-model="detailInfo.maximum" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="农药登记证号" prop="pesticideNumber">
                    <el-input v-model="detailInfo.pesticideNumber" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="GB 2763有限量" prop="finiteQuantity">
                   <el-select v-model="detailInfo.finiteQuantity" @change="changeGb" style="width:100%" :disabled="statusView=='S'?false:true" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                   </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="其他标准" prop="otherStandard" :rules="{required:isGb,message:'请输入其他标准',trigger: 'blur'}">
                     <el-input v-model="detailInfo.otherStandard" maxlength="100" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="药品在用状态" prop="medicineUseStatus">
                      <ic-select table="TT_RMC_PRODUCE_MEDICINE" :disabled="statusView=='S'?false:true" filterable field="MEDICINE_USE_STATUS" clearable v-model="detailInfo.medicineUseStatus"  style="width:100%"></ic-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="状态" >
                    <ic-select table="TT_RMC_PRODUCE_MEDICINE" disabled filterable field="STATUS" clearable v-model="detailInfo.status"  style="width:100%"></ic-select>
                 </el-form-item>
             </el-col>
             <el-col :span="24" v-if="$route.query.id">
                 <el-form-item label="上次修改原因" prop="momentUpdateReason">
                    <el-input  type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit disabled placeholder="请输入内容" v-model="momentUpdateReason"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="24">
                 <el-form-item label="修改原因" prop="modifyReason">
                   <el-tooltip v-if="detailInfo.modifyReason&&detailInfo.modifyReason.length>400" class="item" effect="dark" :content="detailInfo.modifyReason" placement="top-start">
                     <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit :disabled="statusView=='S'?false:true" placeholder="请输入内容" v-model="detailInfo.modifyReason"></el-input>
                   </el-tooltip>
                    <el-input v-else type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit :disabled="statusView=='S'?false:true" placeholder="请输入内容" v-model="detailInfo.modifyReason"></el-input>
                 </el-form-item>
             </el-col>
          </el-row> -->
        </el-form>
      </div>

      <!-- <div class="handle-box" style="margin-top:20px;">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">检测报告</p>
        </div>
        <el-row type="flex" style="margin-top:10px;"  align="middle">
          <el-button  size="small" type="primary" @click="openFile">
              {{$t('common.selectFile')}}
          </el-button>
        </el-row>
        <el-table ref="plxTable" :data="fileTable" style="margin-top:10px;" max-height="500" show-overflow="ellipsis" highlight-current-row>
            <el-table-column align="center" label="文件名称"   prop="documentName">
            <template slot-scope="scope">
                <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
            </template>
            </el-table-column>
            <el-table-column label="附件描述" align="center" prop="docComments"></el-table-column>
            <el-table-column label="上传人" align="center" prop="userName"></el-table-column>
            <el-table-column label="上传时间" align="center" prop="createDate"></el-table-column>
            <el-table-column label="操作" align="center" prop="updateDate">
                <template v-slot="scope">
                    <i class="el-icon-delete" style="color: red;" @click="delFile(scope.row)"></i>
                </template>
            </el-table-column>
        </el-table>
    </div> -->

      <el-dialog title="提示" :visible.sync="fileVisible" width="30%" :before-close="closeFile">
        <uploadFile v-if="fileVisible" @close="closeFile" :detailInfo="detailInfo" :tsReckindId="tsReckindId"></uploadFile>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import commonFunction from "@/utils/dataTableUtils";
import proteinDrug from "@/api/rmcProtein/drug";
import prodMedicine from "@/api/rmcProduce/prodMedicine";
import rules from '@/components/page/RMC/Produce/rmcProDrugList/rules'
import uploadFile from "../../Protein/rmcDrugList/dialog/uploadFile.vue";
import { _debounce } from '@/components/common/reduce'



export default {
  name: '',
  components: {
    IcSelect,
    uploadFile
    // detailDialog
  },
  data() {
    return {
      isOther: false,
      isGb: "",
      momentUpdateReason: "",
      options: [{
        label: 'Y',
        value: 'Y'
      }, {
        label: 'N',
        value: 'N'
      }],
      productNames: [],
      effectiveComponentsList: [],
      tsReckindId: "",
      fileList: [],
      fileVisible: false,
      rules: rules,
      usageList: [],
      dosageFormList: [],
      cultiVarList: [],
      useClassList: [],
      farmGroupList: [],
      farmList: [],
      identity: localStorage.getItem('ms_emplFlag'),
      allDate: [],
      multipleSelection: [],
      category3List: [],
      statusList: [],
      fileTable: [],
      detailInfo: {
        status: "DRAFT",
        cultiVarName: []
      },
      isShow: false,
      showDetailDialog: false,
      tableData: [],
      totalCount: "",
      statusView: "",
      isSet: false,
    }
  },
  created() {
    let functions = store.state.main.functions;
    if (functions.indexOf('RMC_PROD_MEDICINE_SAVE') != -1 || functions.indexOf('RMC_PROD_MEDICINE_SUBMIT') != -1) {
      this.isSet = true
    }
    this.getProductNames()
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      if (ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") != -1) {
        this.statusView = 'C'
      }
    }
    if (!this.$route.query.id) {
      this.getSponsorByUser()
    }
    this.getSelector()
    this.getFarmList()
    this.getdCategory3()
    if (this.$route.query.id) {
      this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo() {
      prodMedicine.queryDetail(this.$route.query.id).then((res) => {
        if (res.data.modifyReason) {
          this.momentUpdateReason = res.data.modifyReason
          res.data.modifyReason = ''
        }
        res.data.cultiVarName = res.data.cultiVarName.split(',')
        res.data.effectiveComponents = res.data.effectiveComponents.split(',')
        this.detailInfo = res.data
      })
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    saveData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.detailInfo.cultiVarName = this.detailInfo.cultiVarName.toString()
          this.detailInfo.effectiveComponents = this.detailInfo.effectiveComponents.toString()
          this.detailInfo.useClass = this.detailInfo.useClass.toString()
          if (!this.detailInfo.modifyReason) {
            this.detailInfo.modifyReason = this.momentUpdateReason
          }
          prodMedicine.saveMedicine(this.detailInfo).then((res) => {
            if (res.code == 200) {
              this.$message.success('保存成功')
              this.routerBack()
            } else {
              this.$message.error(res.msg)
            }
            console.log("查看的保存====", res)
          }).catch((err) => {
            this.detailInfo.cultiVarName = this.detailInfo.cultiVarName.split(',')
          })
        } else {
          return false;
        }
      });
    },
    queryEffectiveComponents: _debounce(function (queryString, cb) {
      let arr = []
      this.effectiveComponentsList.forEach((v) => {
        let obj = {}
        obj.value = v.code
        arr.push(obj)
      })
      var results = arr.filter((a) => {
        return a.value.indexOf(queryString) != -1
      })
      cb(results)
    }, 50),
    selectEffectiveComponents(item) {
      console.log(item);
    },
    submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.detailInfo.cultiVarName = this.detailInfo.cultiVarName.toString()
          this.detailInfo.effectiveComponents = this.detailInfo.effectiveComponents.toString()
          this.detailInfo.useClass = this.detailInfo.useClass.toString()
          if (!this.detailInfo.modifyReason) {
            this.detailInfo.modifyReason = this.momentUpdateReason
          }
          prodMedicine.submitMedicine(this.detailInfo).then((res) => {
            if (res.code == 200) {
              this.$message.success('提交成功')
              this.routerBack()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    },
    changeGb(val) {
      if (val == 'Y') {
        this.isGb = false
      } else if (val == 'N') {
        this.isGb = true
      }
    },
    getSelectorForEffective(val) {
      console.log("🚀 ~ file: detail.vue:517 ~ getSelectorForEffective ~ val:", val)
      if (val === '其他') {
        this.isOther = true
      } else {
        this.isOther = false
        this.detailInfo.effectiveComponentsOther=''

      }
      let str = val.toString()
      if (val && val.length > 0) {
        let params = {
          effectiveComponents: str
        }
        prodMedicine.getSelectorForEffective(params).then((res) => {
          if (res.code == 200) {
            this.$set(this.detailInfo, 'useClass', res.data)
          }
        })
      }
    },
    getProductNames() {
      prodMedicine.getProductNames().then((res) => {
        this.productNames = res.data
      })
    },
    querySearch1: _debounce(function (queryString, cb) {
      console.log("输入数据===", queryString)
      let arr = []
      this.productNames.forEach((v) => {
        let obj = {}
        obj.value = v
        arr.push(obj)
      })
      console.log("rrrrrrrrrrr", arr)
      var results = arr.filter((a) => {
        return a.value.indexOf(queryString) != -1
      })
      cb(results)
    }, 50),
    handleSelect1(item) {
      console.log(item);
    },
    openFile() {
      this.tsReckindId = 'PRODUCE_MEDICINE'
      this.fileVisible = true
    },
    closeFile() {
      this.fileVisible = false
      this.getFileLists()
    },
    getFileLists() {
      QBRApi.getFileLists({
        tsReckindId: "PRODUCE_MEDICINE",
        tsRecId: this.detailInfo.ttRmcProduceMedicineId
      }).then(res => {
        console.log('获取列表', res);
        this.fileList = res
      });
    },
    routerBack() {
      this.$router.back();
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'produce'
        })
        if (this.category3List.length == 1) {
          this.$set(this.detailInfo, 'category3Code', this.category3List[0].key)
          this.$set(this.detailInfo, 'category3Name', this.category3List[0].object)
          this.$refs['detailInfo'].clearValidate(['category3Code']);
        }
      })
    },
    getFarmList() {
      prodMedicine.getSelectorForFram().then((res) => {
        this.farmList = res.data
      })
    },
    getFarmGroupId(val) {
      prodMedicine.getFarmGroup(val).then((res) => {
        this.$set(this.detailInfo, 'farmGroup', res.data)
        // res.data.forEach((v)=>{
        //   let obj={}
        //   obj.name=v
        //   obj.code=v
        //   this.farmGroupList.push(obj)
        // })
      })
    },
    getSponsorByUser() {
      proteinDrug.getSponsorByUser().then((res) => {
        this.$set(this.detailInfo, "sponsorName", res.data.supplierName)
        this.$set(this.detailInfo, "sponsorCode", res.data.supplierCode)
      })
    },
    getSelector() {
      prodMedicine.getSelector().then((res) => {
        res.data.effectiveComponentsList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.effectiveComponentsList.push(obj)
        })
        res.data.selector.cultiVarName.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.cultiVarList.push(obj)
        })
        let set = new Set(res.data.useClassList);
        set.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.useClassList.push(obj)
        })
        res.data.selector.usage.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.usageList.push(obj)
        })
        res.data.selector.dosageForm.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.dosageFormList.push(obj)
        })
        console.log("获取的下拉框列表=====", res)
      })
    }

  },
  extends: commonFunction
}
</script>
<style scoped >
.searchForm .el-col {
  margin-top: 10px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
